export default __webpack_public_path__ + "static/client01-13e7969355beed481b45f483ce15aba0.png";